import { default as energy_45green_45practicesHAyxcBYQeKMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue?macro=true";
import { default as fun_45part_45journeyCar2LOFh17Meta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue?macro=true";
import { default as homesafe_45colorado_45master_45builderXwQBc1WzWWMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue?macro=true";
import { default as indexQ1xPllZCI9Meta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/index.vue?macro=true";
import { default as our_45teamuxky09xZleMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue?macro=true";
import { default as preferred_45lenderQ2MhmcGkIdMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue?macro=true";
import { default as realtor_45resources0lJaqT2k1UMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue?macro=true";
import { default as _91post_93jQ0LTTbSKcMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/blog/[post].vue?macro=true";
import { default as indexmyhIBP9DffMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue?macro=true";
import { default as index9BnmyuXiDIMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46slug_93AyWQXq3qw3Meta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue?macro=true";
import { default as indexNJdWzuhphNMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue?macro=true";
import { default as central_45park_45special_45offer7C2QUGeQ9VMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue?macro=true";
import { default as ask_45a_45questionPfWSvoVkdBMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue?macro=true";
import { default as career_45opportunitiesHuBcHl5y6fMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue?macro=true";
import { default as faqIAYvdDBb2gMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue?macro=true";
import { default as homeowner_45resourcesb16h44uh9kMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue?macro=true";
import { default as index37spu9eD4cMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue?macro=true";
import { default as our_45locationsXYGBEOIwNGMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue?macro=true";
import { default as current_45offerseqMeHFhgFsMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/current-offers.vue?macro=true";
import { default as indexuuuaJWNKcaMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue?macro=true";
import { default as indexJ2rc8FhmvoMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/events/index.vue?macro=true";
import { default as indexuRVDwF4lAzMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue?macro=true";
import { default as indexZ4HH2dqpXwMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue?macro=true";
import { default as indexryaAT8rmXOMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue?macro=true";
import { default as indexZJ13SYpT7cMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue?macro=true";
import { default as indexlZgAnMkbnMMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/index.vue?macro=true";
import { default as knolls_45hoa_45informationQmN7KgkmsyMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue?macro=true";
import { default as land_45acquisitionbWzlOivvGtMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue?macro=true";
import { default as brents_45placeXCBEtcaqK2Meta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue?macro=true";
import { default as experience_45lower_45maintenanceA8W3m7MJegMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue?macro=true";
import { default as _91testimonial_935ukZiho9gSMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue?macro=true";
import { default as indexedSmlCzFfuMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue?macro=true";
import { default as indexktnXYVzYsCMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue?macro=true";
import { default as whats_45lifefullnessLNuMS2qxrEMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue?macro=true";
import { default as _91_46_46_46slug_93F954llpm9DMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue?macro=true";
import { default as my_45favoritesiLjQgoVJ9XMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/my-favorites.vue?macro=true";
import { default as new_45home_45searchn5ZWBIpRm1Meta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/new-home-search.vue?macro=true";
import { default as easyhouseNzOFiovCNhMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue?macro=true";
import { default as limitededitionNNOHwwPsD4Meta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue?macro=true";
import { default as wee_45cottage47zbcuxioOMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue?macro=true";
import { default as indexpsEY3unxcpMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue?macro=true";
import { default as our_45neighborhoodshFSmPQzGcBMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue?macro=true";
import { default as partner_45with_45uswHLxGGVX8SMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue?macro=true";
import { default as peacocksmlF2EGdmOMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/peacock.vue?macro=true";
import { default as privacytermsvU05uxAiaDMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/privacyterms.vue?macro=true";
import { default as sandboxknwDMWTGXuMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/sandbox.vue?macro=true";
import { default as _91_46_46_46slug_93manAuavi48Meta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue?macro=true";
import { default as component_45stubRxtXTXg5rHMeta } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubRxtXTXg5rH } from "/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: energy_45green_45practicesHAyxcBYQeKMeta?.name ?? "about-us-energy-green-practices",
    path: energy_45green_45practicesHAyxcBYQeKMeta?.path ?? "/about-us/energy-green-practices",
    meta: energy_45green_45practicesHAyxcBYQeKMeta || {},
    alias: energy_45green_45practicesHAyxcBYQeKMeta?.alias || [],
    redirect: energy_45green_45practicesHAyxcBYQeKMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue").then(m => m.default || m)
  },
  {
    name: fun_45part_45journeyCar2LOFh17Meta?.name ?? "about-us-fun-part-journey",
    path: fun_45part_45journeyCar2LOFh17Meta?.path ?? "/about-us/fun-part-journey",
    meta: fun_45part_45journeyCar2LOFh17Meta || {},
    alias: fun_45part_45journeyCar2LOFh17Meta?.alias || [],
    redirect: fun_45part_45journeyCar2LOFh17Meta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue").then(m => m.default || m)
  },
  {
    name: homesafe_45colorado_45master_45builderXwQBc1WzWWMeta?.name ?? "about-us-homesafe-colorado-master-builder",
    path: homesafe_45colorado_45master_45builderXwQBc1WzWWMeta?.path ?? "/about-us/homesafe-colorado-master-builder",
    meta: homesafe_45colorado_45master_45builderXwQBc1WzWWMeta || {},
    alias: homesafe_45colorado_45master_45builderXwQBc1WzWWMeta?.alias || [],
    redirect: homesafe_45colorado_45master_45builderXwQBc1WzWWMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue").then(m => m.default || m)
  },
  {
    name: indexQ1xPllZCI9Meta?.name ?? "about-us",
    path: indexQ1xPllZCI9Meta?.path ?? "/about-us",
    meta: indexQ1xPllZCI9Meta || {},
    alias: indexQ1xPllZCI9Meta?.alias || [],
    redirect: indexQ1xPllZCI9Meta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45teamuxky09xZleMeta?.name ?? "about-us-our-team",
    path: our_45teamuxky09xZleMeta?.path ?? "/about-us/our-team",
    meta: our_45teamuxky09xZleMeta || {},
    alias: our_45teamuxky09xZleMeta?.alias || [],
    redirect: our_45teamuxky09xZleMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue").then(m => m.default || m)
  },
  {
    name: preferred_45lenderQ2MhmcGkIdMeta?.name ?? "about-us-preferred-lender",
    path: preferred_45lenderQ2MhmcGkIdMeta?.path ?? "/about-us/preferred-lender",
    meta: preferred_45lenderQ2MhmcGkIdMeta || {},
    alias: preferred_45lenderQ2MhmcGkIdMeta?.alias || [],
    redirect: preferred_45lenderQ2MhmcGkIdMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue").then(m => m.default || m)
  },
  {
    name: realtor_45resources0lJaqT2k1UMeta?.name ?? "about-us-realtor-resources",
    path: realtor_45resources0lJaqT2k1UMeta?.path ?? "/about-us/realtor-resources",
    meta: realtor_45resources0lJaqT2k1UMeta || {},
    alias: realtor_45resources0lJaqT2k1UMeta?.alias || [],
    redirect: realtor_45resources0lJaqT2k1UMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue").then(m => m.default || m)
  },
  {
    name: _91post_93jQ0LTTbSKcMeta?.name ?? "blog-post",
    path: _91post_93jQ0LTTbSKcMeta?.path ?? "/blog/:post()",
    meta: _91post_93jQ0LTTbSKcMeta || {},
    alias: _91post_93jQ0LTTbSKcMeta?.alias || [],
    redirect: _91post_93jQ0LTTbSKcMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/blog/[post].vue").then(m => m.default || m)
  },
  {
    name: indexmyhIBP9DffMeta?.name ?? "blog-category-category",
    path: indexmyhIBP9DffMeta?.path ?? "/blog/category/:category()",
    meta: indexmyhIBP9DffMeta || {},
    alias: indexmyhIBP9DffMeta?.alias || [],
    redirect: indexmyhIBP9DffMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index9BnmyuXiDIMeta?.name ?? "blog",
    path: index9BnmyuXiDIMeta?.path ?? "/blog",
    meta: index9BnmyuXiDIMeta || {},
    alias: index9BnmyuXiDIMeta?.alias || [],
    redirect: index9BnmyuXiDIMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93AyWQXq3qw3Meta?.name ?? "campaigns-slug",
    path: _91_46_46_46slug_93AyWQXq3qw3Meta?.path ?? "/campaigns/:slug(.*)*",
    meta: _91_46_46_46slug_93AyWQXq3qw3Meta || {},
    alias: _91_46_46_46slug_93AyWQXq3qw3Meta?.alias || [],
    redirect: _91_46_46_46slug_93AyWQXq3qw3Meta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexNJdWzuhphNMeta?.name ?? "campaigns",
    path: indexNJdWzuhphNMeta?.path ?? "/campaigns",
    meta: indexNJdWzuhphNMeta || {},
    alias: indexNJdWzuhphNMeta?.alias || [],
    redirect: indexNJdWzuhphNMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: central_45park_45special_45offer7C2QUGeQ9VMeta?.name ?? "central-park-special-offer",
    path: central_45park_45special_45offer7C2QUGeQ9VMeta?.path ?? "/central-park-special-offer",
    meta: central_45park_45special_45offer7C2QUGeQ9VMeta || {},
    alias: central_45park_45special_45offer7C2QUGeQ9VMeta?.alias || [],
    redirect: central_45park_45special_45offer7C2QUGeQ9VMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue").then(m => m.default || m)
  },
  {
    name: ask_45a_45questionPfWSvoVkdBMeta?.name ?? "contact-us-ask-a-question",
    path: ask_45a_45questionPfWSvoVkdBMeta?.path ?? "/contact-us/ask-a-question",
    meta: ask_45a_45questionPfWSvoVkdBMeta || {},
    alias: ask_45a_45questionPfWSvoVkdBMeta?.alias || [],
    redirect: ask_45a_45questionPfWSvoVkdBMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue").then(m => m.default || m)
  },
  {
    name: career_45opportunitiesHuBcHl5y6fMeta?.name ?? "contact-us-career-opportunities",
    path: career_45opportunitiesHuBcHl5y6fMeta?.path ?? "/contact-us/career-opportunities",
    meta: career_45opportunitiesHuBcHl5y6fMeta || {},
    alias: career_45opportunitiesHuBcHl5y6fMeta?.alias || [],
    redirect: career_45opportunitiesHuBcHl5y6fMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue").then(m => m.default || m)
  },
  {
    name: faqIAYvdDBb2gMeta?.name ?? "contact-us-faq",
    path: faqIAYvdDBb2gMeta?.path ?? "/contact-us/faq",
    meta: faqIAYvdDBb2gMeta || {},
    alias: faqIAYvdDBb2gMeta?.alias || [],
    redirect: faqIAYvdDBb2gMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue").then(m => m.default || m)
  },
  {
    name: homeowner_45resourcesb16h44uh9kMeta?.name ?? "contact-us-homeowner-resources",
    path: homeowner_45resourcesb16h44uh9kMeta?.path ?? "/contact-us/homeowner-resources",
    meta: homeowner_45resourcesb16h44uh9kMeta || {},
    alias: homeowner_45resourcesb16h44uh9kMeta?.alias || [],
    redirect: homeowner_45resourcesb16h44uh9kMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue").then(m => m.default || m)
  },
  {
    name: index37spu9eD4cMeta?.name ?? "contact-us",
    path: index37spu9eD4cMeta?.path ?? "/contact-us",
    meta: index37spu9eD4cMeta || {},
    alias: index37spu9eD4cMeta?.alias || [],
    redirect: index37spu9eD4cMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45locationsXYGBEOIwNGMeta?.name ?? "contact-us-our-locations",
    path: our_45locationsXYGBEOIwNGMeta?.path ?? "/contact-us/our-locations",
    meta: our_45locationsXYGBEOIwNGMeta || {},
    alias: our_45locationsXYGBEOIwNGMeta?.alias || [],
    redirect: our_45locationsXYGBEOIwNGMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue").then(m => m.default || m)
  },
  {
    name: current_45offerseqMeHFhgFsMeta?.name ?? "current-offers",
    path: current_45offerseqMeHFhgFsMeta?.path ?? "/current-offers",
    meta: current_45offerseqMeHFhgFsMeta || {},
    alias: current_45offerseqMeHFhgFsMeta?.alias || [],
    redirect: current_45offerseqMeHFhgFsMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/current-offers.vue").then(m => m.default || m)
  },
  {
    name: indexuuuaJWNKcaMeta?.name ?? "events-event",
    path: indexuuuaJWNKcaMeta?.path ?? "/events/:event()",
    meta: indexuuuaJWNKcaMeta || {},
    alias: indexuuuaJWNKcaMeta?.alias || [],
    redirect: indexuuuaJWNKcaMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJ2rc8FhmvoMeta?.name ?? "events",
    path: indexJ2rc8FhmvoMeta?.path ?? "/events",
    meta: indexJ2rc8FhmvoMeta || {},
    alias: indexJ2rc8FhmvoMeta?.alias || [],
    redirect: indexJ2rc8FhmvoMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: indexuRVDwF4lAzMeta?.name ?? "homes-location-community",
    path: indexuRVDwF4lAzMeta?.path ?? "/homes/:location()/:community()",
    meta: indexuRVDwF4lAzMeta || {},
    alias: indexuRVDwF4lAzMeta?.alias || [],
    redirect: indexuRVDwF4lAzMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZ4HH2dqpXwMeta?.name ?? "homes-location-community-models-model",
    path: indexZ4HH2dqpXwMeta?.path ?? "/homes/:location()/:community()/models/:model()",
    meta: indexZ4HH2dqpXwMeta || {},
    alias: indexZ4HH2dqpXwMeta?.alias || [],
    redirect: indexZ4HH2dqpXwMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue").then(m => m.default || m)
  },
  {
    name: indexryaAT8rmXOMeta?.name ?? "homes-location-community-plans-plan",
    path: indexryaAT8rmXOMeta?.path ?? "/homes/:location()/:community()/plans/:plan()",
    meta: indexryaAT8rmXOMeta || {},
    alias: indexryaAT8rmXOMeta?.alias || [],
    redirect: indexryaAT8rmXOMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJ13SYpT7cMeta?.name ?? "homes-location-community-qmi-home",
    path: indexZJ13SYpT7cMeta?.path ?? "/homes/:location()/:community()/qmi/:home()",
    meta: indexZJ13SYpT7cMeta || {},
    alias: indexZJ13SYpT7cMeta?.alias || [],
    redirect: indexZJ13SYpT7cMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue").then(m => m.default || m)
  },
  {
    name: indexlZgAnMkbnMMeta?.name ?? "index",
    path: indexlZgAnMkbnMMeta?.path ?? "/",
    meta: indexlZgAnMkbnMMeta || {},
    alias: indexlZgAnMkbnMMeta?.alias || [],
    redirect: indexlZgAnMkbnMMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: knolls_45hoa_45informationQmN7KgkmsyMeta?.name ?? "knolls-hoa-information",
    path: knolls_45hoa_45informationQmN7KgkmsyMeta?.path ?? "/knolls-hoa-information",
    meta: knolls_45hoa_45informationQmN7KgkmsyMeta || {},
    alias: knolls_45hoa_45informationQmN7KgkmsyMeta?.alias || [],
    redirect: knolls_45hoa_45informationQmN7KgkmsyMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue").then(m => m.default || m)
  },
  {
    name: land_45acquisitionbWzlOivvGtMeta?.name ?? "land-acquisition",
    path: land_45acquisitionbWzlOivvGtMeta?.path ?? "/land-acquisition",
    meta: land_45acquisitionbWzlOivvGtMeta || {},
    alias: land_45acquisitionbWzlOivvGtMeta?.alias || [],
    redirect: land_45acquisitionbWzlOivvGtMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue").then(m => m.default || m)
  },
  {
    name: brents_45placeXCBEtcaqK2Meta?.name ?? "lifestyle-brents-place",
    path: brents_45placeXCBEtcaqK2Meta?.path ?? "/lifestyle/brents-place",
    meta: brents_45placeXCBEtcaqK2Meta || {},
    alias: brents_45placeXCBEtcaqK2Meta?.alias || [],
    redirect: brents_45placeXCBEtcaqK2Meta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue").then(m => m.default || m)
  },
  {
    name: experience_45lower_45maintenanceA8W3m7MJegMeta?.name ?? "lifestyle-experience-lower-maintenance",
    path: experience_45lower_45maintenanceA8W3m7MJegMeta?.path ?? "/lifestyle/experience-lower-maintenance",
    meta: experience_45lower_45maintenanceA8W3m7MJegMeta || {},
    alias: experience_45lower_45maintenanceA8W3m7MJegMeta?.alias || [],
    redirect: experience_45lower_45maintenanceA8W3m7MJegMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue").then(m => m.default || m)
  },
  {
    name: _91testimonial_935ukZiho9gSMeta?.name ?? "lifestyle-reviews-testimonial",
    path: _91testimonial_935ukZiho9gSMeta?.path ?? "/lifestyle/reviews/:testimonial()",
    meta: _91testimonial_935ukZiho9gSMeta || {},
    alias: _91testimonial_935ukZiho9gSMeta?.alias || [],
    redirect: _91testimonial_935ukZiho9gSMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue").then(m => m.default || m)
  },
  {
    name: indexedSmlCzFfuMeta?.name ?? "lifestyle-reviews-category-category",
    path: indexedSmlCzFfuMeta?.path ?? "/lifestyle/reviews/category/:category()",
    meta: indexedSmlCzFfuMeta || {},
    alias: indexedSmlCzFfuMeta?.alias || [],
    redirect: indexedSmlCzFfuMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexktnXYVzYsCMeta?.name ?? "lifestyle-reviews",
    path: indexktnXYVzYsCMeta?.path ?? "/lifestyle/reviews",
    meta: indexktnXYVzYsCMeta || {},
    alias: indexktnXYVzYsCMeta?.alias || [],
    redirect: indexktnXYVzYsCMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: whats_45lifefullnessLNuMS2qxrEMeta?.name ?? "lifestyle-whats-lifefullness",
    path: whats_45lifefullnessLNuMS2qxrEMeta?.path ?? "/lifestyle/whats-lifefullness",
    meta: whats_45lifefullnessLNuMS2qxrEMeta || {},
    alias: whats_45lifefullnessLNuMS2qxrEMeta?.alias || [],
    redirect: whats_45lifefullnessLNuMS2qxrEMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93F954llpm9DMeta?.name ?? "marshallfire-slug",
    path: _91_46_46_46slug_93F954llpm9DMeta?.path ?? "/marshallfire/:slug(.*)*",
    meta: _91_46_46_46slug_93F954llpm9DMeta || {},
    alias: _91_46_46_46slug_93F954llpm9DMeta?.alias || [],
    redirect: _91_46_46_46slug_93F954llpm9DMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesiLjQgoVJ9XMeta?.name ?? "my-favorites",
    path: my_45favoritesiLjQgoVJ9XMeta?.path ?? "/my-favorites",
    meta: my_45favoritesiLjQgoVJ9XMeta || {},
    alias: my_45favoritesiLjQgoVJ9XMeta?.alias || [],
    redirect: my_45favoritesiLjQgoVJ9XMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: new_45home_45searchn5ZWBIpRm1Meta?.name ?? "new-home-search",
    path: new_45home_45searchn5ZWBIpRm1Meta?.path ?? "/new-home-search",
    meta: new_45home_45searchn5ZWBIpRm1Meta || {},
    alias: new_45home_45searchn5ZWBIpRm1Meta?.alias || [],
    redirect: new_45home_45searchn5ZWBIpRm1Meta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/new-home-search.vue").then(m => m.default || m)
  },
  {
    name: easyhouseNzOFiovCNhMeta?.name ?? "our-homes-home-collections-easyhouse",
    path: easyhouseNzOFiovCNhMeta?.path ?? "/our-homes/home-collections/easyhouse",
    meta: easyhouseNzOFiovCNhMeta || {},
    alias: easyhouseNzOFiovCNhMeta?.alias || [],
    redirect: easyhouseNzOFiovCNhMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue").then(m => m.default || m)
  },
  {
    name: limitededitionNNOHwwPsD4Meta?.name ?? "our-homes-home-collections-limitededition",
    path: limitededitionNNOHwwPsD4Meta?.path ?? "/our-homes/home-collections/limitededition",
    meta: limitededitionNNOHwwPsD4Meta || {},
    alias: limitededitionNNOHwwPsD4Meta?.alias || [],
    redirect: limitededitionNNOHwwPsD4Meta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue").then(m => m.default || m)
  },
  {
    name: wee_45cottage47zbcuxioOMeta?.name ?? "our-homes-home-collections-wee-cottage",
    path: wee_45cottage47zbcuxioOMeta?.path ?? "/our-homes/home-collections/wee-cottage",
    meta: wee_45cottage47zbcuxioOMeta || {},
    alias: wee_45cottage47zbcuxioOMeta?.alias || [],
    redirect: wee_45cottage47zbcuxioOMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue").then(m => m.default || m)
  },
  {
    name: indexpsEY3unxcpMeta?.name ?? "our-homes",
    path: indexpsEY3unxcpMeta?.path ?? "/our-homes",
    meta: indexpsEY3unxcpMeta || {},
    alias: indexpsEY3unxcpMeta?.alias || [],
    redirect: indexpsEY3unxcpMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue").then(m => m.default || m)
  },
  {
    name: our_45neighborhoodshFSmPQzGcBMeta?.name ?? "our-neighborhoods",
    path: our_45neighborhoodshFSmPQzGcBMeta?.path ?? "/our-neighborhoods",
    meta: our_45neighborhoodshFSmPQzGcBMeta || {},
    alias: our_45neighborhoodshFSmPQzGcBMeta?.alias || [],
    redirect: our_45neighborhoodshFSmPQzGcBMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue").then(m => m.default || m)
  },
  {
    name: partner_45with_45uswHLxGGVX8SMeta?.name ?? "partner-with-us",
    path: partner_45with_45uswHLxGGVX8SMeta?.path ?? "/partner-with-us",
    meta: partner_45with_45uswHLxGGVX8SMeta || {},
    alias: partner_45with_45uswHLxGGVX8SMeta?.alias || [],
    redirect: partner_45with_45uswHLxGGVX8SMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue").then(m => m.default || m)
  },
  {
    name: peacocksmlF2EGdmOMeta?.name ?? "peacock",
    path: peacocksmlF2EGdmOMeta?.path ?? "/peacock",
    meta: peacocksmlF2EGdmOMeta || {},
    alias: peacocksmlF2EGdmOMeta?.alias || [],
    redirect: peacocksmlF2EGdmOMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/peacock.vue").then(m => m.default || m)
  },
  {
    name: privacytermsvU05uxAiaDMeta?.name ?? "privacyterms",
    path: privacytermsvU05uxAiaDMeta?.path ?? "/privacyterms",
    meta: privacytermsvU05uxAiaDMeta || {},
    alias: privacytermsvU05uxAiaDMeta?.alias || [],
    redirect: privacytermsvU05uxAiaDMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/privacyterms.vue").then(m => m.default || m)
  },
  {
    name: sandboxknwDMWTGXuMeta?.name ?? "sandbox",
    path: sandboxknwDMWTGXuMeta?.path ?? "/sandbox",
    meta: sandboxknwDMWTGXuMeta || {},
    alias: sandboxknwDMWTGXuMeta?.alias || [],
    redirect: sandboxknwDMWTGXuMeta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93manAuavi48Meta?.name ?? "videos-slug",
    path: _91_46_46_46slug_93manAuavi48Meta?.path ?? "/videos/:slug(.*)*",
    meta: _91_46_46_46slug_93manAuavi48Meta || {},
    alias: _91_46_46_46slug_93manAuavi48Meta?.alias || [],
    redirect: _91_46_46_46slug_93manAuavi48Meta?.redirect,
    component: () => import("/codebuild/output/src474175046/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue").then(m => m.default || m)
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/about-us/get-our-brochure/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/about-us/in-the-news/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/about-us/realtor-program/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/about-us/what-we-do/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/about-us/who-we-are/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/build-with-us/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/career-opportunities/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/career-opportunities/administrative-assistant-2/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/career-opportunities/director-of-warranty-services/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/career-opportunities/land-development-entitlements-coordinator/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/contact-us/ask-a-question/thank-you/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/contact-us/warranty-services/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/email-signup/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/get-updates/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/get-updates/thank-you/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/how-to-video-library/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/lifestyle/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/locations/lanterns-at-rock-creek/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/locations/silver-leaf/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/locations/wee-cottage-at-north-end-80238/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/locations/wee-cottage-at-rogers-farm/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/locations/west-edge-at-colliers-hill/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/login/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/lost-password/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/maintenance-items/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/marshall-fire-response/thank-you-loi/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/neighborhoods-map-test/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/organism-page/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/our-homes/home-collections/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/our-homes/home-collections/lanterns-series/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/our-homes/home-collections/opportunities-series/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/our-homes/photo-gallery/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/our-homes/photo-gallery/gourmet-kitchens/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/our-homes/photo-gallery/home-offices/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/our-homes/photo-gallery/living-rooms/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/our-homes/photo-gallery/outdoor-living-spaces/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/our-homes/photo-gallery/relaxing-master-suites/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/register/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/reset-password/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/resources-lower-maintenance/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/style-guide/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  },
  {
    name: component_45stubRxtXTXg5rHMeta?.name ?? undefined,
    path: component_45stubRxtXTXg5rHMeta?.path ?? "/warranty-service-request/",
    meta: component_45stubRxtXTXg5rHMeta || {},
    alias: component_45stubRxtXTXg5rHMeta?.alias || [],
    redirect: component_45stubRxtXTXg5rHMeta?.redirect,
    component: component_45stubRxtXTXg5rH
  }
]